import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doDelete, doPost, doPostDownload } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const SourceListAction = createAsyncThunk("sourceList",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.esgChatSourceList, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const ExportSourceAction = createAsyncThunk("exportSourceList",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPostDownload(urls?.esgChatExportSourceList, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const DeleteSourceAction = createAsyncThunk("deleteSource",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await doDelete(urls?.deleteSource, payload);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const SourceListSlice = createSlice({
    name: "sourceList",
    initialState: {
        isLoading: false,
        data: false,
        success: false,
        error: null
    },
    reducers: {
        SourceListReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [SourceListAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [SourceListAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [SourceListAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const ExportSourceListSlice = createSlice({
    name: "exportSourceList",
    initialState: {
        isLoading: false,
        data: false,
        success: false,
        error: null
    },
    reducers: {
        ExportSourceListReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [ExportSourceAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ExportSourceAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ExportSourceAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const DeleteSourceSlice = createSlice({
    name: "deleteSource",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false
    },
    reducers: {
        DeleteSourceReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [DeleteSourceAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [DeleteSourceAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [DeleteSourceAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})


export const { SourceListReset } = SourceListSlice.actions
export const { DeleteSourceReset } = DeleteSourceSlice.actions
export const { ExportSourceListReset } = ExportSourceListSlice.actions
export default SourceListSlice.reducer
